/*
 * @Author: Teemo Ding
 * @Date: 2021-10-18 09:36:30
 * @LastEditTime: 2021-10-18 09:39:03
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/ColorPicker/TwitterColorPicker.tsx
 */
import React from 'react';
import { TwitterPicker, ColorResult } from 'react-color';
import { CaretDownOutlined } from '@ant-design/icons';

import { Button, PopOver } from 'src/components/Antd';
import css from './css.less';
import Options from './ColorOptions/ColorOptions';

interface IProps {
  onChange(hex: string): void;
  color: string;
  tabIndex?: number;
  multi?: boolean;
  options?: any;
  disableAlpha?: boolean;
  disable?: boolean;
  id?: string;
}

const TwitterColorPicker = (props: IProps) => {
  const { disable, multi, onChange, color, options, disableAlpha, id } = props;

  return (
    <div className={css.wrapper}>
      <PopOver
        id={id}
        {...(disable && { visible: false })}
        placement='bottomRight'
        overlayClassName={css.popoverClassName}
        overlay={
          <div
            {...(!multi && { style: { top: 46 } })}
            className={css.colorPickerContainer}>
            {multi ? (
              <TwitterPicker
                width={250}
                disableAlpha={disableAlpha}
                color={color || 'rgba(255,255,255,1)'}
                onChange={(color: ColorResult) => {
                  const alpha = color.rgb.a;
                  let rgbaColor = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;
                  if (alpha === 1) {
                    rgbaColor = color.hex;
                  }
                  onChange(rgbaColor);
                }}
                presetColors={[
                  {
                    color: 'rgba(0,0,0,1)',
                    title: 'Black',
                  },
                  {
                    color: 'rgba(255,255,255,1)',
                    title: 'Plain White',
                  },
                ]}
              />
            ) : (
              <Options
                options={options || ['rgba(0,0,0,1)', 'rgba(255,255,255,1)']}
                onClick={onChange}
              />
            )}
          </div>
        }
        trigger='click'>
        <div className={css.btn}>
          <div
            className={css.colorDisplay}
            style={{ background: color || 'rgba(0,0,0,1)' }}
          />
          <Button className={css.triggerContainer}>
            <CaretDownOutlined className={css.icon} />
          </Button>
        </div>
      </PopOver>
      {/* <div className={css.colorText}>{color}</div> */}
    </div>
  );
};

export default TwitterColorPicker;
